import { useEffect, useState } from 'react';
import { NAVIGATION_MAIN_SCROLL_BUTTON_SIZE, NAVIGATION_MAIN_SCROLL_FADE_SIZE, } from '../styles/navigation-main.styled';
const scrollToEdge = (navigationMainRef) => (direction) => {
    const navigationMainElement = navigationMainRef.current;
    if (!navigationMainElement) {
        return;
    }
    const { scrollLeft, clientWidth } = navigationMainElement;
    const scrollButtonAndFadeSize = NAVIGATION_MAIN_SCROLL_BUTTON_SIZE + NAVIGATION_MAIN_SCROLL_FADE_SIZE;
    const scrollAmount = clientWidth - scrollButtonAndFadeSize;
    if (direction === 'left') {
        navigationMainElement.scrollTo({
            left: scrollLeft - scrollAmount,
            behavior: 'smooth',
        });
    }
    else {
        navigationMainElement.scrollTo({
            left: scrollLeft + scrollAmount,
            behavior: 'smooth',
        });
    }
};
export const useScrollButtons = (navigationMainRef) => {
    const [hasScroll, setHasScroll] = useState(false);
    const [scrollButtonLeft, setScrollButtonLeft] = useState(false);
    const [scrollButtonRight, setScrollButtonRight] = useState(false);
    useEffect(() => {
        const navigationMainElement = navigationMainRef.current;
        if (!navigationMainElement) {
            return () => { };
        }
        const scrollButtonAndFadeSize = NAVIGATION_MAIN_SCROLL_BUTTON_SIZE + NAVIGATION_MAIN_SCROLL_FADE_SIZE;
        const checkHasScrollAndPosition = () => {
            const navigationMainContainerHasScroll = navigationMainElement.scrollWidth > navigationMainElement.clientWidth;
            setHasScroll(navigationMainContainerHasScroll);
            if (navigationMainContainerHasScroll) {
                const { scrollLeft, scrollWidth, clientWidth } = navigationMainElement;
                const scrollRight = scrollWidth - scrollLeft - clientWidth;
                setScrollButtonLeft(scrollLeft > scrollButtonAndFadeSize);
                setScrollButtonRight(scrollRight > scrollButtonAndFadeSize);
            }
        };
        setTimeout(() => {
            checkHasScrollAndPosition();
            window.addEventListener('resize', checkHasScrollAndPosition);
            navigationMainElement.addEventListener('scroll', checkHasScrollAndPosition);
        }, 0);
        return () => {
            window.removeEventListener('resize', checkHasScrollAndPosition);
            navigationMainElement.removeEventListener('scroll', checkHasScrollAndPosition);
        };
    }, [navigationMainRef.current]);
    return {
        hasScroll,
        scrollButtonLeft,
        scrollButtonRight,
        scrollToEdge: scrollToEdge(navigationMainRef),
    };
};
